module.exports = __webpack_public_path__ + "media/components/country-flag/static/cx-5619052f06e0eccbcc64733ba8f84c80.svg";